import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setStep } from '../store/byoSlice'

const Bundle = ({ data }) => {
 
  const {step, color, material, materialSelected, addons, addonSeleted, addon2Seleted} = useSelector((state) => state.byo)
  const dispatch = useDispatch()
  let basePrice = parseFloat(data.metafields.color[color].list_price)
  let nextStep = step + 1
  if(step === 2 && data.addons.length === 0) {
    nextStep = 4
    if(typeof data.addons2 === 'undefined' || !data.addons2) nextStep = 5
  } else if(step === 3 && (typeof data.addons2 === 'undefined' || !data.addons2))
    nextStep = 5
  
  let previousStep = step - 1
  if(step === 5 && (typeof data.addons2 === 'undefined' || !data.addons2)) {
    previousStep = 3
    if(data.addons.length === 0) previousStep = 2
  } else if(step === 4 && data.addons.length === 0)
    previousStep = 2

  let total = 0
  const productOption = step === 1 ? data.metafields.color[color] : (step === 2 ? data.metafields.material[materialSelected] : null)
  let variantIndex = data.metafields.material.length * color + material
  let optionImage = null
  const dataAddons = step == 3 ? data.addons : data.addons2
  switch (step) {
    case 1:
      total = productOption.list_price
      optionImage = productOption.option_image
      break;
    case 2:
      total = parseFloat(data.metafields.color[color].list_price) + parseFloat(productOption.list_price)
      if(variantIndex < data.variants.length && data.variants[variantIndex].data.featured_image) optionImage = data.variants[variantIndex].data.featured_image.src
      break;
    case 3:
      total = parseFloat(data.metafields.color[color].list_price) + parseFloat(data.metafields.material[material].list_price)
      if(variantIndex < data.variants.length) total = data.variants[variantIndex].data.price / 100.0
      dataAddons.map((addon) => {
        addon.variants.map((variant) => {
          if(addons.filter((a) => a.productId === addon.product.id && a.variantId === variant.data.id).length) total += variant.data.price / 100.0
        })
      })
      if(variantIndex < data.variants.length && data.variants[variantIndex].data.featured_image) optionImage = data.variants[variantIndex].data.featured_image.src
      break;
    case 4:
      total = parseFloat(data.metafields.color[color].list_price) + parseFloat(data.metafields.material[material].list_price)
      if(variantIndex < data.variants.length) total = data.variants[variantIndex].data.price / 100.0
      data.addons.map((addon) => {
        addon.variants.map((variant) => {
          if(addons.filter((a) => a.productId === addon.product.id && a.variantId === variant.data.id).length) total += variant.data.price / 100.0
        })
      })
      data.addons2.map((addon) => {
        addon.variants.map((variant) => {
          if(addons.filter((a) => a.productId === addon.product.id && a.variantId === variant.data.id).length) total += variant.data.price / 100.0
        })
      })
      if(variantIndex < data.variants.length && data.variants[variantIndex].data.featured_image) optionImage = data.variants[variantIndex].data.featured_image.src
      break;
    default:
      if(variantIndex < data.variants.length && data.variants[variantIndex].data.featured_image) optionImage = data.variants[variantIndex].data.featured_image.src
      break;
  }

  const isAddonSelected = () => {
    const dataAddons = step === 3 ? data.addons : data.addons2
    return dataAddons.filter((addon) => addons.filter((a) => a.productId === addon.product.id && addon.variants.filter((v) => v.data.id === a.variantId).length > 0).length > 0).length
  }

  const addonLineItem = (step, addon, index) => {
    let dataAddons = step == 3 ? data.addons : data.addons2
    const product = dataAddons.filter((a) => a.product.id === addon.productId).length > 0 ? dataAddons.filter((a) => a.product.id === addon.productId)[0] : null
    if(product) {
      const variant = product.variants.filter((variant) => variant.data.id === addon.variantId)[0]
      if(typeof variant != 'undefined' && variant) {
        const variantImage = variant.data.featured_image ? variant.data.featured_image.src : (product.product.featured_image ? product.product.featured_image : null)
        return <div className='flex items-center justify-between border-b border-black py-2' key={`${step}-addon-${index}`}>
          <span className='font-bold inline-flex items-center text-xs'>
            { variantImage && <img className='w-10 mr-1' src={variantImage} /> }
            { variant.data.name }
          </span>
          <span className='font-mono text-[0.75rem] leading-6 text-black'>${ (variant.data.price / 100.0).toLocaleString(undefined, { maximumFractionDigits: 2 }) }</span>
        </div>
      }
    }
  }

  const modalHtml = () => {
    return <div className='text-puffco-light-black-3'>
      <div className='text-right text-xl font-medium mb-6'>Build</div>
      <div className='text-right border-b border-black pb-2 text-lg font-mono'>
        
      ${step === 3 || step === 4 ? parseFloat(total).toLocaleString(undefined, { maximumFractionDigits: 2 }) : parseFloat(total).toLocaleString(undefined, { maximumFractionDigits: 2 })}
      </div>

      {
        data.metafields.color[color] &&
        <div className='flex items-center justify-between border-b border-black py-2'>
          <span className='font-bold inline-flex items-center text-xs'>
            { data.metafields.color[color].option_image && <img className='w-10 mr-1' src={data.metafields.color[color].option_image} /> }
            { data.metafields.color[color].display_name }
          </span>
          <span className='font-mono text-[0.75rem] leading-6 text-black'>${ parseFloat(data.metafields.color[color].list_price).toLocaleString(undefined, { maximumFractionDigits: 2 }) }</span>
        </div>
      }
      {
        step > 1 && data.metafields.material[material] &&
        <div className='flex items-center justify-between border-b border-black py-2'>
          <span className='font-bold inline-flex items-center text-xs'>
            { data.metafields.material[material].option_image && <img className='w-10 mr-1' src={data.metafields.material[material].option_image} /> }
            { data.metafields.material[material].display_name }
          </span>
          <span className='font-mono text-[0.75rem] leading-6 text-black'>${ parseFloat(data.metafields.material[material].list_price).toLocaleString(undefined, { maximumFractionDigits: 2 }) }</span>
        </div>
      }
      {
        step > 1 && data.metafields.material[material].display_name.toLowerCase().includes('proxy') &&
        <div className='flex items-center justify-between border-b border-black py-2'>
          <span className='font-bold inline-flex items-center text-xs'>
            <img className='w-10 mr-1' src={data.free_case_image} alt='Free Case' width='40' height='40' loading='lazy' />
            Free Case
          </span>
          <span className='font-mono text-[0.75rem] leading-6 text-black'>$0</span>
        </div>
      }
      {
        (step === 3 || step === 4) && addons.length > 0 &&
        addons.map((addon, index) => addonLineItem(3, addon, index))
      }
      {
        step === 4 && addons.length > 0 &&
        addons.map((addon, index) => addonLineItem(4, addon, index))
      }
    </div>
  }
  const openModal = () => {
    openPuffcoModal(document.querySelector('#mobileBundleTotal').innerHTML)
  }

  return (
    <div className={`relative bg-puffco-grey-8 h-0 lg:h-auto pb-[115.4%] lg:pb-[10%] lg:pt-[3.75rem] lg:overflow-hidden px-6 ${step < 5 ? 'lg:w-1/2' : 'lg:w-2/3 hidden lg:block'}`}>
      {optionImage ? 
        <img className={`absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[70%] h-[70%] lg:w-[60%]   lg:h-[60%] object-contain ${step == 1 ? 'top-[58%]' : 'top-1/2'}`} src={ optionImage } /> : null}
      {step == 1 &&
        <div className='h-full flex flex-col items-center justify-between mt-14 lg:mt-20'>
          <div>
            <div className='text-center font-medium text-xs mb-2 lg:text-lg'>Build Your Own Proxy Experience</div>
            <div className='text-center font-semibold text-2xl lg:text-5xl leading-tight'>One Proxy. Many Paths.</div>
          </div>
          <div className='text-[0.75rem] leading-6 text-black hidden lg:block'>Proxy Base is not sold separately.</div>
        </div> 
      }

      { total > 0 && <button className={`absolute bottom-4 left-4 border-black border uppercase font-mono text-xs text-black rounded-md h-[2.125rem] inlinex-flex lg:hidden items-center justify-between px-4`}
        onClick={() => openModal()}>Build ${step === 3 || step === 4 ? parseFloat(total).toLocaleString(undefined, { maximumFractionDigits: 2 }) : parseFloat(total).toLocaleString(undefined, { maximumFractionDigits: 2 })}
        </button>}

      {step > 1 ? <button className={`backbtn absolute left-4 top-12 z-50 text-puffco-light-black-3 font-mono text-xs h-[2.125rem] inline-flex lg:hidden items-center justify-between px-4 before:content-[''] before:w-2 before:h-2 before:border-black before:border-l-2 before:border-t-2 before:inline-block before:mr-3 before:transform before:rotate-[-45deg]`} onClick={() => dispatch(setStep(previousStep))}>Back</button> : <span><span></span></span>}
      <button className={`absolute bottom-4 right-4 bg-black uppercase font-mono text-xs text-white rounded-md h-[2.125rem] inlinex-flex lg:hidden items-center justify-between px-4 after:content-[''] after:w-2 after:h-2 after:border-white after:border-l-2 after:border-t-2 after:inline-block after:ml-3 after:transform after:rotate-[135deg]`}
        onClick={() => dispatch(setStep(nextStep))}>
        {step < 3 ? 'Next' : (nextStep == 5 ? 'Finish' : (isAddonSelected() ? 'Next' : 'No Thanks'))}
      </button>

      <div className='hidden' id="mobileBundleTotal">{ modalHtml() }</div>
    </div>
  )
}

export default Bundle